import React, { PureComponent } from 'react';

import CustomText from '../Typography/CustomText/CustomText';

type DateType = Date | moment.Moment | string;
type ShortcutType = {
  label: React.ReactNode;
  hotkey: string;
  date: DateType;
}[];
export interface CalendarShortcutsProps {
  shortcuts: ShortcutType;
  onDateClick: (date: DateType) => void;
  closeCalendar: () => void;
}

class CalendarShortcuts extends PureComponent<CalendarShortcutsProps> {
  handlerFunc: (event) => void;

  componentWillUnmount() {
    window.removeEventListener('keypress', this.handlerFunc);
  }

  handleClick(date: DateType) {
    this.props.onDateClick(date);
    this.props.closeCalendar();
  }

  handleKeyPress(shortcuts: ShortcutType, eventKey: string) {
    shortcuts.forEach(shortcut => {
      if (shortcut.hotkey.toLowerCase() === eventKey.toLowerCase()) {
        this.props.onDateClick(shortcut.date);
        this.props.closeCalendar();
      }
    });
  }

  renderShortcuts() {
    window.addEventListener(
      'keypress',
      (this.handlerFunc = e => {
        if (e.target.tagName === 'SELECT') {
          e.preventDefault();
        }
        this.handleKeyPress(this.props.shortcuts, e.key);
      }),
    );
    return this.props.shortcuts.map((shortcut, index) => (
      <li key={index} className="ink-calendar--list--item">
        <button onClick={() => this.handleClick(shortcut.date)} className="ink-calendar--list--button" type="button">
          <CustomText display="inline">{shortcut.label}</CustomText>
          <span className="ink-calendar--list--hint">
            <CustomText size="xsmall" color="gray" display="inline">
              Press&#160;
              {shortcut.hotkey}
            </CustomText>
          </span>
        </button>
      </li>
    ));
  }

  render() {
    return <ul className="ink-calendar--list">{this.renderShortcuts()}</ul>;
  }
}

export default CalendarShortcuts;
